<div class="card">
    <div class="card-body">
      <div class="row">
        <!-- <div class="col-lg-12"> -->
          <!-- <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner> -->
        <!-- </div> -->
        
          <div  class="float-left my-1 ml-10">
            <label >{{'header.assesmentyear' | translate }}<span class="text-star">*</span></label>
            <select [(ngModel)]="formInputfilter['ay']" class="form-control custom-selectbox">
              <option value="" [disabled]="true">{{'header.assesmentyear' | translate }}</option>
              <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
            </select>
          </div>
        
        <!-- <div class="float-left my-1 ml-10">
          <label>{{'header.state' | translate }}</label>
          <select placeholder="Select State" [(ngModel)]="selectedstate"(change) = "showdistrictdropdown(selectedstate)" class="form-control custom-selectbox" >
            <option value=undefined>{{'tabledataforstates.all' | translate}}</option>
          <option *ngFor="let state of statelists"  value="{{state.uuid}}">{{'tabledataforstates.' + state.name | translate}}</option>
      </select>
      </div>
        <div class="float-left my-1 ml-10" *ngIf="showdistdrop">
          <label>{{'header.district' | translate}}</label>
          <select [(ngModel)]="selectedistrict" (change) = "getdistuuid(selectedistrict)"  class="form-control custom-selectbox">
            <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
            <option *ngFor="let district of districtentityList" value="{{district['uuid']}}">{{'districtsdata.' + district['name'] | translate}}</option>
        </select>
     </div> -->

     <div class="float-left my-1 ml-10">
      <label>{{'header.district' | translate }}</label>
      <select [(ngModel)]="formInputfilter['lu']" disabled="" class="form-control custom-selectbox">
        <option *ngFor="let state of userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']"
          value="{{state['entityUUID']}}">{{'districtsdata.' + state['entityName'] | translate}}</option>
      </select>
    </div>

  <div class="float-left my-1 ml-10">
    <label>{{'aggregatedpage.aggregatedscore' | translate}}</label>
    <select [(ngModel)]="aggregatedScore" class="form-control custom-selectbox selectdis">
      <option value="undefined">{{'aggregatedpage.selectagg' | translate}}</option>
      <option value="quaterlywise">{{'aggregatedpage.quat' | translate}}</option>
      <option value="halfearlywise">{{'aggregatedpage.half' | translate}}</option>
      <option value="annualwise">{{'aggregatedpage.annual' | translate}}</option>
    </select>
  </div>
  <div class="float-left my-1 ml-10" *ngIf = "aggregatedScore == 'quaterlywise'">
    <label>{{'aggregatedpage.quat' | translate}}</label>
    <select [(ngModel)]="quaterlyScore" (change)="scoredropdownchange()" class="form-control custom-selectbox selectdis">
      <option value="undefined">{{'aggregatedpage.selectavg' | translate}}</option>
      <option value="quaterlyscore">{{'aggregatedpage.quat1' | translate}}</option>
      <option value="quaterlyscore1">{{'aggregatedpage.quat2' | translate}}</option>
      <option value="quaterlyscore2">{{'aggregatedpage.quat3' | translate}}</option>
      <option value="quaterlyscore3">{{'aggregatedpage.quat4' | translate}}</option>
    </select>
  </div>
  <div class="float-left my-1 ml-10" *ngIf = "aggregatedScore == 'halfearlywise'">
    <label>{{'aggregatedpage.half' | translate}}</label>
    <select [(ngModel)]="halfearlyScore" (change)="halfearlydropdownchange()" class="form-control custom-selectbox selectdis">
      <option value="undefined">{{'aggregatedpage.selectavg' | translate}}</option>
      <option value="halfearlyscore">{{'aggregatedpage.half1' | translate}}</option>
      <option value="halfearlyscore1">{{'aggregatedpage.half2' | translate}}</option>
    </select>
  </div>
        <div class="col-md-2" *ngIf = "aggregatedScore == 'quaterlywise'">
          <button class="btn btn-info pointer"(click)= "getquataggdata()"style="margin-top:31px;"
            type="submit">{{'dataSubs.SUBMIT' | translate }}</button>
        </div>
        <div class="col-md-2" *ngIf = "aggregatedScore == 'halfearlywise'">
          <button class="btn btn-info pointer"(click)= "gethalfaggdata()"style="margin-top:31px;"
            type="submit">{{'dataSubs.SUBMIT' | translate }}</button>
        </div>
        <div class="col-md-2" *ngIf = "aggregatedScore == 'annualwise'">
          <button class="btn btn-info pointer"(click)= "getannualaggdata()"style="margin-top:31px;"
            type="submit">{{'dataSubs.SUBMIT' | translate }}</button>
        </div>
      </div>
  <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm" *ngIf = "showtabledata">
     <!-- <cdk-virtual-scroll-viewport  #scrollViewport  -->
      <!-- itemSize="50" [style.height]="tableData.length > 0 ? '500px' : '185px'"> -->
    <table class="table table-striped text-center table-sm mt-1">
      <thead class="thead-light">
        <tr>
          <th class="positiontest">
            <div class="custom-control custom-checkbox" *ngIf="!userdetails['isReadOnly']">
              <input type="checkbox" (change)="checkallset(checkall)" name="selectall" [(ngModel)]="checkall"
                class="custom-control-input" id="selectall">
              <label class="custom-control-label" for="selectall"></label>
            </div>
            <input type="checkbox" name="selectall" class="custom-control-input" id="selectall">
          </th>
        <th>{{'dataSubs.sno' | translate}}</th>
        <th>{{'dataSubs.distname' | translate}}</th>
        <th *ngIf = "aggregatedScore == 'quaterlywise'">{{'aggregatedpage.quatscore' | translate}}</th>
        <th *ngIf = "aggregatedScore == 'halfearlywise'">{{'aggregatedpage.halfscore' | translate}}</th>
        <th *ngIf = "aggregatedScore == 'annualwise'">{{'aggregatedpage.annualscore' | translate}}</th>
        </tr>
      </thead>
      <tbody class="text-white">
        <ng-container>
                <tr>
                 <td></td>
                 <td></td>
                 <td></td>
                 <td></td>
                </tr>
        </ng-container>
      </tbody>
    </table>
     <!-- </cdk-virtual-scroll-viewport> -->
     <!-- <div class="row" *ngIf="tableData.length == 0">
      <div class="col-12 nodata" >
        No Data to Display
       </div>
   </div> -->
  </div>
  <!-- <div class="text-center" *ngIf="showbuttons" style="margin-top: 20px;">
    
      <button *ngIf="!adminpage && !userdetails['isReadOnly']" class="btn btn-info btm-sm mr-3" (click)="submitweights()"
        type="submit">Submit for Approval</button>
      <button *ngIf="adminpage" class="btn btn-info mr-3" (click)="submitweights()"
        type="submit">Submit</button>
  
      <button *ngIf="!userdetails['isReadOnly']" class="btn btn-info pointer"  (click)="reset()"
        type="submit">Reset</button>
  </div> -->
  </div>
  </div>